import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsModule } from '../../core/analytics/analytics.module';
import { LocaleModule } from '../../core/locale/locale.module';
import { NotificationModule } from '../../core/notification/notification.module';
import { RoutingModule } from '../../core/routing/routing.module';
import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { SwapLanguageModule } from '../swap-language/swap-language.module';
import { ToastModule } from '../toast/toast.module';
import { LoginFooterComponent } from './footer/login-footer/login-footer.component';
import { GuestLayoutComponent } from './guest-layout/guest-layout.component';
import { LayoutComponent } from './layout.component';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { SideNavigationComponent } from './navigation/side-navigation/side-navigation.component';
import { SummaryHeadingComponent } from './summary-heading/summary-heading.component';

@NgModule({
	declarations: [
		LayoutComponent,
		LoginLayoutComponent,
		GuestLayoutComponent,
		SideNavigationComponent,
		LoginFooterComponent,
		SummaryHeadingComponent,
	],
	imports: [
		AnalyticsModule,
		CommonModule,
		LocaleModule,
		NgOptimizedImage,
		NotificationModule,
		RouterOutlet,
		RoutingModule,
		SpinnerModule,
		SwapLanguageModule,
		ToastModule,
		DynamicFormModule,
	],
	exports: [LayoutComponent, LoginLayoutComponent, GuestLayoutComponent, SummaryHeadingComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule {}
